import { createAction, props } from "@ngrx/store";

export default {
  setNewReleaseNote: createAction("[Release Notes] hasNewRelease setted", (value: boolean) => ({ value })),
  reset: createAction("[Release Notes] reseted"),
  error: createAction("[Release Notes] error", props<{ error: string }>())
};
